<template>
  <div class="market-marketing-index">
    <el-tabs v-model="tabsKey" type="card" :closable="false" :before-leave="onTabClick" >
      <el-tab-pane label="会员销售数据">
        <div class="tab-content">
          <SalesData></SalesData>
        </div>
      </el-tab-pane>
      <el-tab-pane label="卡，积分数据">
        <div class="tab-content">
          <CardPointData></CardPointData>
        </div>
      </el-tab-pane>
      <el-tab-pane label="男女比例">
        <div class="tab-content">
          <SexRatio></SexRatio>
        </div>
      </el-tab-pane>
      <el-tab-pane label="年龄数据">
        <div class="tab-content">
          <AgeData></AgeData>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SexRatio from './components/sexRatio'
import SalesData from './components/salesData'
import CardPointData from './components/cardPointData'
import AgeData from './components/ageData'
export default {
  name: "marketingIndex",
  components: {
    SexRatio,
    SalesData,
    CardPointData,
    AgeData
  },
  data() {
    return {
      tabsKey: 0
    };
  },
  created () {
  },
  methods: {
    onTabClick() {

    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-marketing-index {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;

  .tab-content {
    margin-top: -30px;
  }
}
</style>
